import { render, staticRenderFns } from "./leadDetailModal.vue?vue&type=template&id=2c819959"
import script from "./leadDetailModal.vue?vue&type=script&lang=js"
export * from "./leadDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports